import { atom } from "recoil";
import { KeyboardShortcut, triggerTypes } from "../Types/KeyboardShortcut";

export const generalShortcutsAtom = atom({
    key: "generalShortcuts",
    default: [] as KeyboardShortcut[],
})

export const annotationShortcutsAtom = atom({
    key: "annotationShortcuts",
    default: [] as KeyboardShortcut[],
})

export const hotkeysEnabledAtom = atom<boolean>({
    key: "hotkeysEnabled",
    default: true
})

export function updateHotkeyTrigger(config: KeyboardShortcut, triggerType: string, newTrigger: string) {
    switch(triggerType) {
        case triggerTypes.PRIMARY:
            config.triggers[0] = newTrigger
            break;
        case triggerTypes.SECONDARY:
            config.triggers[1] = newTrigger
            break;
        default:
            throw new Error("Bad trigger type: " +  triggerType)
    }

    return config
}

export const loadHotkeysFromConfigs = (hotkeyConfigs: KeyboardShortcut[]) => {
    return hotkeyConfigs.map((config: KeyboardShortcut, index: number) => {
        // Create a new object to avoid mutating read-only Recoil values
        const id = config.id || `TEMP-${Math.random()}-${Date.now()}}-${index}`
        
        // Ensure triggers array has exactly 2 elements
        const triggers: [string | null, string | null] = [
            config.triggers[0] ?? null,
            config.triggers[1] ?? null
        ]

        // Create new data object if it exists
        const data = config.data ? {
            ...config.data,
            id: id
        } : undefined

        return {
            ...config,
            id,
            triggers,
            data
        }
    })
}
